import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import React from 'react';

import { Field, TextOutput } from 'Components/Core';
import { ListFieldSection, SectionGroup } from 'Components/Layout';
import { toMessageProps } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import { Message } from 'Data/ViewModels/IApiDataModel';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import { useSelector } from 'react-redux';
import BsEnIsoLiquidLimitDeterminationSection from './LiquidLimitDeterminationSection';
import BsEnIsoLiquidLimitEquipmentDetailsSection from './LiquidLimitEquipmentDetailsSection';
import {
  BsEnIsoLiquidLimitAverageValuesSection,
  BsEnIsoLiquidLimitCorrelationFactorSection,
  BsEnIsoLiquidLimitTrialsSection,
} from './MethodB';

let BsEnIsoLiquidLimitMethodBSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const resultCannotBeObtained = useSelector(
    pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false), (np) => !np)
  );

  const liquidLimitMessages = useSelector(
    pipe(
      createWorksheetSelector!('LiquidLimit.Messages'),
      (m) => (m as Array<Message>)?.filter((m) => ['LiquidLimit'].includes(m.PropertyName)),
      (m) => m.map(toMessageProps)
    ),
    deepEquals
  );

  return (
    <>
      <NamePrefixModifier appendNamePrefix="LiquidLimit">
        <BsEnIsoLiquidLimitEquipmentDetailsSection />
        <BsEnIsoLiquidLimitDeterminationSection />
        {resultCannotBeObtained && (
          <>
            <BsEnIsoLiquidLimitTrialsSection />
            <BsEnIsoLiquidLimitAverageValuesSection />
            <BsEnIsoLiquidLimitCorrelationFactorSection />
          </>
        )}
      </NamePrefixModifier>
      <SectionGroup heading="Result">
        <ListFieldSection>
          <Field input={<TextOutput />} name="Results.LiquidLimitText" messages={liquidLimitMessages} />
        </ListFieldSection>
      </SectionGroup>
    </>
  );
};

BsEnIsoLiquidLimitMethodBSection = withInjectedProps(BsEnIsoLiquidLimitMethodBSection);

export { BsEnIsoLiquidLimitMethodBSection };
export default BsEnIsoLiquidLimitMethodBSection;
